import React from "react";
import ServiceOne from "../../assets/business-loan-img.png";
import { useNavigate } from "react-router-dom";
import { FaImage, FaIdCard, FaFileAlt, FaHome, FaUsers, FaBusinessTime } from "react-icons/fa";
import { MdOutlineDescription } from "react-icons/md";


const BusinessLoanOffer = () => {
  const navigate = useNavigate();
  const plans = [
    {
      loanType: "business",
      title: "Business Loan",
    },
  ];

  const handleApplyClick = (loanType) => {
    navigate("/otp-verification/business-loan", { state: { loanType } });
  };

  return (
    <div className="loan-offer-wrapper">
      <div className="ourservice-logo">
        <div className="ourservice-text">
          <h2 className="ourservice-offer-subtitle">Business Loan</h2>
        </div>
        <p className="offer-title-ourservice offer-submain-title">
          {" "}
          Get Business Loan From{" "}
          <span className="highlight-color">₹3 Lakh to ₹1 Crore*</span>
        </p>
      </div>

      <div className="loan-highlights">
        <div className="salary-rate-pair">
          <div className="salary-rate-list">
            <div className="salary-rate-box">
              <p>Right Lender Approval in</p>
              <h3>1 Hr*</h3>
            </div>
            <div className="salary-rate-box">
              <p>Interest Rate Starts @</p>
              <h3>15%*</h3>
            </div>
            <div className="salary-rate-box">
              <p>Tenure up to</p>
              <h3>48*</h3>
              <p>Months</p>
            </div>
            <div className="salary-rate-box">
              <p>EMI</p>
              <h3>₹2783*</h3>
              <p>P/M</p>
            </div>
          </div>
        </div>
        <p className="offer-subtitle highlight-rate">
          Collateral Free SME Loan - Term Loan - Working Capital for Private
          limited -Proprietorship & Partnership Companies
        </p>
      </div>

      <div className="rate-cards-container">
        <h4 className="offer-title-ourservice">Who Can Apply</h4>
        <div className="rate-cards-list">
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>CIBIL 720 & Above
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Age 25 to 65
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Business Registered
              Self-Employed
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>GST Mandatory 3 Year
              Vintage Minimum Required
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Annual Turnover 12 Lakhs
              & Above
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Own House is Must
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Doctors Own a Clinic
            </p>
          </div>
        </div>
      </div>

      <div className="rate-cards-container">
        <h4 className="offer-title-ourservice">Documents</h4>
        <div className="rate-cards-list">
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Selfie (or ) Photo
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Pan & Aadhaar /
              E-Aadhaar
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Last 1 Year CA/SB/ CC/
              OD Account Statement
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>GST Registration Copy
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Last 2 Year ITR
            </p>
          </div>
          <div className="rate-card">
            <p className="eligibility-text">
              <span className="ourservice-icon">●</span>Co-Applicant Details if
              Required By Lender
            </p>
          </div>
        </div>
      </div>
      <div className="offer-subtitle">
        <p>
          <span className="highlight-rate">Service to Tamil Nadu Only</span><br />
          (Right Lender Serviceable PIN code)
        </p>
      </div>

      <div className="apply-now-button">
        {plans.map((plan, index) => (
          <button
            className="apply-loan-button"
            key={index}
            onClick={() => handleApplyClick(plan.loanType)}
          >
            Proceed
          </button>
        ))}
      </div>
    </div>
  );
};

export default BusinessLoanOffer;
